var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AuthLayout", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.save.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "login-form__title" }, [
          _vm._v("Cambiar contraseña"),
        ]),
        _vm.required
          ? _c("div", { staticClass: "login-form__subtitle" }, [
              _vm._v(
                "Es tu primer ingreso. Para continuar, cambiá la contraseña temporal por una que solo vos conozcas."
              ),
            ])
          : _c("div", { staticClass: "login-form__subtitle" }, [
              _vm._v("Ingresá tu contraseña actual y elegí una nueva."),
            ]),
        _c("div", { staticClass: "login-form__fields" }, [
          _c("div", [
            _c(
              "label",
              {
                staticClass: "login-form__label",
                attrs: { for: "current-password" },
              },
              [_vm._v("Contraseña actual")]
            ),
            (_vm.show ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.current_password,
                      expression: "current_password",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "current-password",
                    name: "current_password",
                    "data-vv-as": "contraseña actual",
                    autocomplete: "current-password",
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.current_password)
                      ? _vm._i(_vm.current_password, null) > -1
                      : _vm.current_password,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.current_password,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.current_password = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.current_password = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.current_password = $$c
                      }
                    },
                  },
                })
              : (_vm.show ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.current_password,
                      expression: "current_password",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "current-password",
                    name: "current_password",
                    "data-vv-as": "contraseña actual",
                    autocomplete: "current-password",
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.current_password, null) },
                  on: {
                    change: function ($event) {
                      _vm.current_password = null
                    },
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.current_password,
                      expression: "current_password",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "current-password",
                    name: "current_password",
                    "data-vv-as": "contraseña actual",
                    autocomplete: "current-password",
                    type: _vm.show ? "text" : "password",
                  },
                  domProps: { value: _vm.current_password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.current_password = $event.target.value
                    },
                  },
                }),
            _c("span", { staticClass: "red--text login-form__field-error" }, [
              _vm._v(_vm._s(_vm.errors.first("current_password"))),
            ]),
          ]),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "login-form__label",
                attrs: { for: "new-password" },
              },
              [_vm._v("Contraseña nueva")]
            ),
            _c("div", { staticClass: "login-form__password" }, [
              (_vm.show ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          min: 8,
                          regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/,
                        },
                        expression:
                          "{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }",
                      },
                    ],
                    ref: "password",
                    staticClass: "login-form__input",
                    attrs: {
                      id: "new-password",
                      name: "password",
                      "data-vv-as": "contraseña nueva",
                      autocomplete: "new-password",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.show ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          min: 8,
                          regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/,
                        },
                        expression:
                          "{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }",
                      },
                    ],
                    ref: "password",
                    staticClass: "login-form__input",
                    attrs: {
                      id: "new-password",
                      name: "password",
                      "data-vv-as": "contraseña nueva",
                      autocomplete: "new-password",
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          min: 8,
                          regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/,
                        },
                        expression:
                          "{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }",
                      },
                    ],
                    ref: "password",
                    staticClass: "login-form__input",
                    attrs: {
                      id: "new-password",
                      name: "password",
                      "data-vv-as": "contraseña nueva",
                      autocomplete: "new-password",
                      type: _vm.show ? "text" : "password",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
              _c(
                "button",
                {
                  staticClass: "login-form__toggle",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.show
                      ? "Ocultar contraseñas"
                      : "Mostrar contraseñas",
                  },
                  on: {
                    click: function ($event) {
                      _vm.show = !_vm.show
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(_vm._s(_vm.show ? "mdi-eye" : "mdi-eye-off")),
                  ]),
                ],
                1
              ),
            ]),
            _c("span", { staticClass: "red--text login-form__field-error" }, [
              _vm._v(_vm._s(_vm.errors.first("password"))),
            ]),
          ]),
          _c("div", [
            _c(
              "label",
              {
                staticClass: "login-form__label",
                attrs: { for: "password-confirmation" },
              },
              [_vm._v("Repetir contraseña nueva")]
            ),
            (_vm.show ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_confirmation,
                      expression: "password_confirmation",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password",
                      expression: "'required|confirmed:password'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "password-confirmation",
                    name: "password_confirmation",
                    "data-vv-as": "repetir contraseña",
                    autocomplete: "new-password",
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.password_confirmation)
                      ? _vm._i(_vm.password_confirmation, null) > -1
                      : _vm.password_confirmation,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.password_confirmation,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.password_confirmation = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.password_confirmation = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.password_confirmation = $$c
                      }
                    },
                  },
                })
              : (_vm.show ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_confirmation,
                      expression: "password_confirmation",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password",
                      expression: "'required|confirmed:password'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "password-confirmation",
                    name: "password_confirmation",
                    "data-vv-as": "repetir contraseña",
                    autocomplete: "new-password",
                    type: "radio",
                  },
                  domProps: {
                    checked: _vm._q(_vm.password_confirmation, null),
                  },
                  on: {
                    change: function ($event) {
                      _vm.password_confirmation = null
                    },
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_confirmation,
                      expression: "password_confirmation",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password",
                      expression: "'required|confirmed:password'",
                    },
                  ],
                  staticClass: "login-form__input",
                  attrs: {
                    id: "password-confirmation",
                    name: "password_confirmation",
                    "data-vv-as": "repetir contraseña",
                    autocomplete: "new-password",
                    type: _vm.show ? "text" : "password",
                  },
                  domProps: { value: _vm.password_confirmation },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.password_confirmation = $event.target.value
                    },
                  },
                }),
            _c("span", { staticClass: "red--text login-form__field-error" }, [
              _vm._v(_vm._s(_vm.errors.first("password_confirmation"))),
            ]),
          ]),
          _c("div", { staticClass: "login-form__hint" }, [
            _vm._v("Al menos 8 caracteres, con letras y números."),
          ]),
          _c(
            "button",
            {
              staticClass: "login-form__submit",
              attrs: { type: "submit", disabled: _vm.loading },
            },
            [
              _vm._v(
                _vm._s(_vm.loading ? "Guardando..." : "Cambiar contraseña")
              ),
            ]
          ),
        ]),
        _c(
          "button",
          {
            staticClass: "login-form__link",
            attrs: { type: "button" },
            on: { click: _vm.logout },
          },
          [_vm._v(_vm._s(_vm.required ? "Cerrar sesión" : "Volver"))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }